export default function Pencil({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none">
      <path
        d="M19.3438 6.3125C20.1875 7.15625 20.1875 8.5 19.375 9.3125L9.5 19.25L4.84375 20C4.34375 20.0938 3.90625 19.6562 4 19.1562L4.75 14.5L14.6875 4.625C15.5 3.8125 16.8438 3.8125 17.6562 4.625L19.3438 6.3125ZM7.75 13.4375H9.0625V14.9375H10.5625V16.25L15.8438 10.9375L13.0625 8.15625L7.75 13.4375ZM6.5625 18.3438L8.84375 17.9375L9.4375 17.375V16.0625H7.9375V14.5625H6.625L6.0625 15.1562L5.65625 17.4375L6.5625 18.3438ZM18.4062 8.34375C18.6875 8.0625 18.6875 7.59375 18.375 7.28125L16.6875 5.59375C16.4062 5.3125 15.9375 5.3125 15.6562 5.59375L14.125 7.125L16.875 9.875L18.4062 8.34375Z"
        fill="currentColor"
      />
    </svg>
  );
}
